import { render } from "./MyNotifications.vue?vue&type=template&id=787d48de&scoped=true"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"

import "./MyNotifications.vue?vue&type=style&index=0&id=787d48de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787d48de"]])

export default __exports__